// extracted by mini-css-extract-plugin
module.exports = {"new":"style_new__R-10q"};